'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Image as StyledImage } from './elements';
import { TemplateContext } from '../TemplateContext';
export const Image = ({
  ...rest
}) => {
  const context = React.useContext(TemplateContext);
  return /*#__PURE__*/React.createElement(StyledImage, _extends({
    assetType: context.assetType
  }, rest));
};